module.exports = __webpack_public_path__ + "static/media/strong11.7a36c145.jpg";